import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import Home from './components/Home'

class App extends Component {
  render() {
    return (
      <Home/>
    );
  }
}

export default App;
